export const hasMembershipForClub = (clubSlug, membershipData) => {
  let hasMembership = false
  membershipData.forEach((m) => {
    m.plans.forEach((p) => {
      if (m.slug === clubSlug && p.is_member) {
        hasMembership = true
      }
    })
  })
  return hasMembership
}

export const hasMembershipForPlan = (planSlug, membershipData) => {
  let hasMembership = false
  membershipData.forEach((m) => {
    m.plans.forEach((p) => {
      if (p.slug === planSlug && p.is_member) {
        hasMembership = true
      }
    })
  })
  return hasMembership
}

export const determineDefaultSelectedPlan = (membershipData) => {
  let defaultPlan = ''
  membershipData.forEach((m) => {
    if (!hasMembershipForClub(m.slug, membershipData) && !defaultPlan) {
      defaultPlan = m.plans[0].slug
    }
  })
  return defaultPlan
}

export const memberOfAll = (membershipData) => {
  return membershipData.every((m) =>
    hasMembershipForClub(m.slug, membershipData),
  )
}

export const getClubCrumbs = (thisClubText) => {
  return [
    {
      to: '/',
      text: 'Wine Access',
    },
    {
      to: '/club/',
      text: 'Wine Clubs',
    },
    {
      to: null,
      text: thisClubText,
    },
  ]
}
